import {
    server
} from "@/api";

const prefix = 'api/community'

export const paginate = async (params) => {
    return await server().get(prefix, { params });
}

export const bookmark = async (id) => {
    return await server().post(`${prefix}/${id}/bookmark`);
}

export const getMember = async (id) => {
    return await server().get(`${prefix}/${id}`);
}


const communityApi = {
    paginate,
    bookmark,
    getMember
};

export default communityApi;